
// import { Link } from "react-router-dom";
// import "./NevBar.css";
// import { useCart } from "../../context/CartContext";
// import { useAuth } from "../../context/AuthContext/AuthContext";

// export function NevBar(prop) {
//   const { cart } = useCart(); // global cart
//   const { user, role, logout } = useAuth();

//   return (
//     <div>
//       <nav className="d-flex justify-content-between align-items-center p-2 m-1 navbar-custom shadow-lg">

//         {/* Brand Title */}
//         <div
//           className="fw-bold rounded-circle d-flex align-items-center justify-content-center"
//           style={{
//             width: "150px",
//             height: "30px",
//             color: "#fff",
//             boxShadow: "0 0 8px rgba(0, 179, 134, 0.8)",
//           }}
//         >
//           <span className="fw-bolder fs-5 text-black-50">{prop.BrandTitle}</span>
//         </div>

//         {/* Menu Items */}
//         <div>
//           {prop.MenuItems &&
//             prop.MenuItems.map((item, index) => (
//               <Link
//                 key={index}
//                 to={item === "Home" ? "/" : `/${item.toLowerCase()}`}
//                 className="navbar-item px-3 mx-1 fw-bold text-decoration-none text-black-50"
//               >
//                 {item}
//               </Link>
//             ))}
//         </div>

//         {/* Login / Dashboard / Cart */}
//         <div className="d-flex align-items-center gap-3">

//           {/* =============================
//               🔐 ADMIN DASHBOARD BUTTON
//               Show only when admin logged in
//           ============================== */}
//           {role === "admin" && (
//             <Link
//               to="/admin/dashboard"
//               className="d-flex align-items-center justify-content-center rounded px-3 py-1 fw-bold"
//               style={{
//                 backgroundColor: "#00b386",
//                 color: "#fff",
//                 textDecoration: "none",
//                 boxShadow: "0 0 8px rgba(0, 179, 134, 0.8)",
//               }}
//             >
//               Admin Panel
//             </Link>
//           )}

//           {/* =============================
//               🔐 LOGIN BUTTON
//               Hide when ANY user logged in
//           ============================== */}
//           {!user && (
//             <Link
//               to="/login"
//               className="d-flex align-items-center justify-content-center rounded-circle"
//               style={{
//                 width: "38px",
//                 height: "38px",
//                 backgroundColor: "#f1f1f1",
//                 boxShadow: "0 0 10px rgba(0,0,0,0.2)",
//                 cursor: "pointer",
//                 textDecoration: "none",
//                 color: "#000",
//                 fontSize: "20px"
//               }}
//             >
//               <i className="bi bi-person"></i>
//             </Link>
//           )}

//           {/* =============================
//               🔐 PROFILE ICON
//               Show only when user logged in (non-admin)
//           ============================== */}
//           {user && role !== "admin" && (
//             <Link
//               to="/profile"
//               className="d-flex align-items-center justify-content-center rounded-circle"
//               style={{
//                 width: "38px",
//                 height: "38px",
//                 backgroundColor: "#667eea",
//                 boxShadow: "0 0 10px rgba(102, 126, 234, 0.5)",
//                 cursor: "pointer",
//                 textDecoration: "none",
//                 color: "#fff",
//                 fontSize: "20px"
//               }}
//               title="My Profile & Orders"
//             >
//               <i className="bi bi-person-circle"></i>
//             </Link>
//           )}

//           {/* =============================
//               🔐 LOGOUT BUTTON (Optional)
//               Show only when user logged in
//           ============================== */}
//           {user && (
//             <button
//               onClick={logout}
//               className="btn btn-sm fw-bold"
//               style={{
//                 backgroundColor: "#f43f5e",
//                 color: "white",
//                 borderRadius: "5px",
//                 padding: "6px 12px",
//                 border: "none",
//                 boxShadow: "0 0 10px rgba(244, 63, 94, 0.6)",
//               }}
//             >
//               Logout
//             </button>
//           )}

//           {/* Cart Icon */}
//           <Link
//             to="/cart"
//             className="position-relative text-decoration-none"
//             style={{ fontSize: "24px", color: "#000" }}
//           >
//             🛒

//             {/* Cart Count Badge */}
//             {cart.length > 0 && (
//               <span
//                 className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
//                 style={{ fontSize: "12px" }}
//               >
//                 {cart.length}
//               </span>
//             )}
//           </Link>

//         </div>

//       </nav>
//     </div>
//   );
// }


import { Link } from "react-router-dom";
import "./NevBar.css";
import { useCart } from "../../context/CartContext";
import { useAuth } from "../../context/AuthContext/AuthContext";

export function NevBar(prop) {
  const { cart } = useCart();
  const { user, role, logout } = useAuth();

  return (
    <div>
      <nav className="d-flex justify-content-between align-items-center p-2 m-1 navbar-custom shadow-lg">

        {/* Brand Title */}
        <div
          className="fw-bold rounded-circle d-flex align-items-center justify-content-center"
          style={{
            width: "150px",
            height: "30px",
            color: "#fff",
            boxShadow: "0 0 8px rgba(0, 179, 134, 0.8)",
          }}
        >
          <span className="fw-bolder fs-5 text-black-50">{prop.BrandTitle}</span>
        </div>

        {/* Menu Items */}
        <div>
          {prop.MenuItems &&
            prop.MenuItems.map((item, index) => (
              <Link
                key={index}
                to={item === "Home" ? "/" : `/${item.toLowerCase()}`}
                className="navbar-item px-3 mx-1 fw-bold text-decoration-none text-black-50"
              >
                {item}
              </Link>
            ))}
        </div>

        <div className="d-flex align-items-center gap-3">

          {/* =============================
              ADMIN DASHBOARD + LOGOUT
          ============================== */}
          {role === "admin" && (
            <>
              <Link
                to="/admin/dashboard"
                className="d-flex align-items-center justify-content-center rounded px-3 py-1 fw-bold"
                style={{
                  backgroundColor: "#00b386",
                  color: "#fff",
                  textDecoration: "none",
                  boxShadow: "0 0 8px rgba(0, 179, 134, 0.8)",
                }}
              >
                Admin Panel
              </Link>

              <button
                onClick={logout}
                className="btn btn-sm fw-bold"
                style={{
                  backgroundColor: "#f43f5e",
                  color: "white",
                  borderRadius: "5px",
                  padding: "6px 12px",
                  border: "none",
                  boxShadow: "0 0 10px rgba(244, 63, 94, 0.6)",
                }}
              >
                Logout
              </button>
            </>
          )}

          {/* =============================
              LOGIN ICON (when NOT logged in)
          ============================== */}
          {!user && (
            <Link
              to="/login"
              className="d-flex align-items-center justify-content-center rounded-circle"
              style={{
                width: "38px",
                height: "38px",
                backgroundColor: "#f1f1f1",
                boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                cursor: "pointer",
                textDecoration: "none",
                color: "#000",
                fontSize: "20px",
              }}
            >
              <i className="bi bi-person"></i>
            </Link>
          )}

          {/* =============================
              PROFILE ICON (ONLY customer)
              ⚡ NO Logout Button Here
          ============================== */}
          {user && role !== "admin" && (
            <Link
              to="/profile"
              className="d-flex align-items-center justify-content-center rounded-circle"
              style={{
                width: "38px",
                height: "38px",
                backgroundColor: "#667eea",
                boxShadow: "0 0 10px rgba(102, 126, 234, 0.5)",
                cursor: "pointer",
                textDecoration: "none",
                color: "#fff",
                fontSize: "20px",
              }}
              title="My Profile & Orders"
            >
              <i className="bi bi-person-circle"></i>
            </Link>
          )}

          {/* Cart Icon */}
          <Link
            to="/cart"
            className="position-relative text-decoration-none"
            style={{ fontSize: "24px", color: "#000" }}
          >
            🛒

            {cart.length > 0 && (
              <span
                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                style={{ fontSize: "12px" }}
              >
                {cart.length}
              </span>
            )}
          </Link>

        </div>
      </nav>
    </div>
  );
}
